<template>
  <div class="page-container">
    <nav-bar></nav-bar>
    <div class="page">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <div class="title-coontainer">
              <h5 class="card-title">Subscribers ({{ count }})</h5>
              <div class="filters-cont">
                <pager :limit="limit" @onPageChanged="onPageChanged"></pager>
                <div
                  style="margin-left: 1rem"
                  title="Download Data"
                  class="bt-filters"
                  @click="downloadData"
                >
                  <img src="../assets/ic_download.png" alt="" />
                </div>
              </div>
            </div>

            <div class="empty" v-if="subscribers.length <= 0">
              <img src="../assets/empty.svg" />
              <span>No data to show ...</span>
            </div>

            <table class="table table-striped" v-else>
              <thead>
                <tr>
                  <th style="width: 50%" scope="col">Email</th>
                  <th style="width: 50%" scope="col">Name</th>
                </tr>
              </thead>
              <tbody>
                <tr v-bind:key="item.id" v-for="item in subscribers">
                  <td>{{ item.email }}</td>
                  <td>{{ item.name }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "../components/NavBar";
import { HTTP, URLS } from "../network/http";
import Pager from "../components/Pager";
var NotificationsController = require("../components/NotificationsController.js");
const ExcelExporter = require("../utils/excel");
import moment from "moment";

export default {
  name: "Subscribers",
  components: {
    NavBar,
    Pager,
  },
  data() {
    return {
      keyword: "",
      resultsPerPage: 10,
      count: 0,
      page: 1,
      limit: 0,
      subscribers: [],
    };
  },
  methods: {
    downloadData() {
      ExcelExporter.JSONToCSVConvertor(this.subscribers, "Subscribers", true);
    },
    onPageChanged(page) {
      this.page = page;
      this.getsubscribers();
    },
    getsubscribers() {
      NotificationsController.showActivityIndicator();
      const ctx = this;
      var url = URLS.SUBSCRIBERS.LIST;
      url = url + "?limit=" + this.resultsPerPage;
      url = url + "&page=" + this.page;

      HTTP.get(url)
        .then((response) => {
          let data = response.data;
          let rows = data.rows;
          ctx.count = data.count;
          let limit = Math.ceil(data.count / ctx.resultsPerPage);
          ctx.limit = limit;
          ctx.previousEnable = limit > 0;
          ctx.nextEnable = ctx.page < limit;
          ctx.subscribers = rows;
          NotificationsController.hideActivityIndicator();
        })
        .catch((err) => {
          NotificationsController.hideActivityIndicator();
        });
    },
  },
  mounted() {
    this.getsubscribers();
    this.moment = moment;
  },
};
</script>

<style lang="scss">
.page-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;

  nav-bar {
    height: 100px;
    width: 100%;
  }

  .page {
    width: 100%;
    height: 90%;
    overflow-y: scroll;
  }

  .title-coontainer {
    width: 100%;
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    align-items: center;

    .filters-cont {
      display: flex;
      flex-direction: row;
      button {
        margin-right: 10px;
      }
    }
  }
}

.table-card {
  box-shadow: 0px 0px 10px 0px #bdbdbd;
}

.actions {
  button {
    margin-right: 4px;
  }
}
</style>
